export const INVOICE_STATUSES = {
    PENDING: "PENDING",
    PAID: "PAID",
    OVERDUE: "OVERDUE",
    CANCELLED: "CANCELLED"
};
export const INVOICE_STATUS_LABELS = {
    [INVOICE_STATUSES.PENDING]: "Pending",
    [INVOICE_STATUSES.PAID]: "Paid",
    [INVOICE_STATUSES.OVERDUE]: "Overdue",
    [INVOICE_STATUSES.CANCELLED]: "Cancelled"
};
export const INVOICE_FILTER_ALL = "ALL";
